import styled from 'styled-components';

export const NoLayoutWrap = styled.div``;
